
import Clarity from '@microsoft/clarity';
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CLARITY_PROJECT_ID } from '../../../project_config';
import { LoginHelper } from "../../../utils/LoginHelper";
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import Footer from "../../common/footer/Footer";
import { FooterButton } from "../../common/footer/FooterButton";
import Header from "../../common/header/Header";
import SeoMeta from "../../common/seo/SeoMeta";
import CreateSection from "./create/CreateSection";
import MyPublicationSection from "./my_publication/MyPublicationSection";
import PublicationSection from "./publication/PublicationSection";
import SearchSection from "./search/SearchSection";

const LIST_SEO_DESCRIPTION =
	"مقالات تخصصی روان‌شناسی، تربیت، روابط و سلامت روان از تیم «همراهتیم». مطالب کاربردی برای والدین و مراجعان.";

export default function PublicationList() {
	Clarity.init(CLARITY_PROJECT_ID);
	const navigate = useNavigate();
	const [isDesktop, setIsDesktop] = useState(() => window.innerWidth > 768);
	const linkDataList = [
		{ label: 'خانه', href: '/' },
		{ label: 'مقالات', href: '/publication_list/' },
	];
	const [searchParams] = useSearchParams();
	const queryParam = searchParams.get('query');

	useEffect(() => {
		const onResize = () => setIsDesktop(window.innerWidth > 768);
		window.addEventListener("resize", onResize);
		return () => window.removeEventListener("resize", onResize);
	}, []);

	function onSearch(newQuery) {
		if (newQuery === queryParam) {
			return;
		}
		navigate(`/publication_list/?query=${newQuery ? newQuery : ''}`);
	}

	const listTitle = queryParam
		? `جستجو: ${queryParam}`
		: "مقالات روان‌شناسی و آموزش";

	return (
		<>
			<SeoMeta
				title={listTitle}
				description={
					queryParam
						? `نتایج جستجوی «${queryParam}» در مقالات ${LIST_SEO_DESCRIPTION.split(".")[0]}.`
						: LIST_SEO_DESCRIPTION
				}
				path={
					queryParam
						? `/publication_list/?query=${encodeURIComponent(queryParam)}`
						: "/publication_list/"
				}
				type="website"
			/>

			<div className="bg-[#F0F6FC] flex min-h-screen flex-col">
				<div className="flex flex-1 flex-col">
					<Header isDesktop={isDesktop} />
					<div className="bg-white">
						<div className={`${isDesktop ? 'w-[1200px]' : ''} mx-auto`}>
							<Breadcrumb linkDataList={linkDataList} />
						</div>
					</div>
					<div
						className={`${isDesktop ? "w-[1200px]" : "px-[10px]"} mx-auto flex flex-1 flex-col gap-5 pt-6 md:pt-8 pb-4`}
					>
						{LoginHelper.isLoggedIn() &&
							LoginHelper.getProfileMode() === LoginHelper.MODE_TYPE_DOCTOR && (
							<>
								<CreateSection isDesktop={isDesktop} />
								<MyPublicationSection isDesktop={isDesktop} />
							</>
						)}
						<SearchSection initQuery={queryParam} onSearch={onSearch} />
						<PublicationSection isDesktop={isDesktop} query={queryParam} />
					</div>
				</div>
				<Footer isDesktop={isDesktop} activeButton={FooterButton.PUBLICATIONS} />
			</div>
		</>
	);
}
